import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { combineLatest } from 'rxjs';
import { CycleValidationDTO } from 'src/app/shared/dtos/cycleValidationDTO';
import { BcModel } from 'src/app/shared/models/societe-linked/bc/bc.model';
import { CycleBcService } from 'src/app/shared/services/bc/cycle-bc.service';
import { UserService } from 'src/app/shared/services/user.service';


export interface DialogData {
  idBc: number;
  idSociete: number;
  codeCa1: string;
}

@Component({
  selector: 'app-modal-cycle-validation',
  templateUrl: './modal-cycle-validation.component.html',
  styleUrls: ['./modal-cycle-validation.component.scss']
})
export class ModalCycleValidationComponent implements OnInit {

  cyclesValidation: CycleValidationDTO[] = [];

  constructor(public dialog: MatDialog
    , public dialogRef: MatDialogRef<Component>
    , @Inject(MAT_DIALOG_DATA) public data: DialogData
    , private cycleBcService: CycleBcService) { }
  
  ngOnInit(): void {
    this.cycleBcService.getAllValidationFromBC(this.data.idBc, this.data.idSociete, this.data.codeCa1).subscribe(x => {
      this.cyclesValidation = x;
    })
  }
}
